import { useQuery } from 'react-query';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { coverLetterMetaData } from 'services/coverLetter';
import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import UseModal from 'hooks/use-modal';

import CoverLetterDataWrapper from 'components/pages/coverLetter/coverletterdatawrapper/CoverLetterDataWrapper';
import Spinner from '@core/components/spinner/Spinner';
import DashboardMenuDesktop from '@core/components/dashboardMenuDesktop/DashboardMenuDesktop';
import ActionButton from '@core/components/actionbutton/ActionButton';
import CoverLetterEmptyState from 'components/pages/coverLetter/coverletteremptystate/CoverLetterEmptyState';
import Modal from '@core/components/Modal/Modal';
import PremiumFeatureModal from '@core/components/premiumfeaturemodal/PremiumFeatureModal';
import GoPremiumBanner from '@core/components/gopremiumbanner/GoPremiumBanner';

import AddSquareIcon from 'assets/icons/add-square-icon.svg';

import classes from './index.module.scss';

const index = () => {
    const router = useRouter();
    const { show: showGoPremium, showModal: showGoPremiumModal, destroyModal: destroyGoPremiumModal } = UseModal();
    const hasSubscription = useSelector(state => state.user.hasSubscription);
    const availableTrialDays = useSelector(state => state.user.available_trial_days);
    const { data, isLoading } = useQuery(['user-has-coverletter'], coverLetterMetaData);
    const seoProps = generateSeoProps({
        title: 'Cover Letter Builder: Templates & AI Hints - Pharmuni',
        description: 'Auto-generate tailored cover letters packed with GMP keywords and quantified wins—download fast and apply with confidence to high-value pharma roles.',
        canonical: 'cover-letter'
    });

    return (
        <>
            <NextSeo {...seoProps} />
            {!hasSubscription && availableTrialDays === 0 && (<GoPremiumBanner />)}
            {isLoading ? (
                <div
                    className={`${classes['loading']} d-flex flex-row align-items-center justify-content-center`}>
                    <Spinner />
                </div>
            ) : (
                <>
                    {(data && data.data.count !== 0) ? (
                        <>
                            <div className={classes["button-wrapper"]}>
                                <ActionButton
                                    kind='secondary'
                                    className={`${classes['new-button']} `}
                                    onClick={() => (hasSubscription || true) ? router.push('/cover-letter/new') : showGoPremiumModal()}
                                >
                                    <AddSquareIcon />
                                    Create Cover letter
                                </ActionButton>
                            </div>
                            <CoverLetterDataWrapper hasSubscription={true} showGoPremiumModal={showGoPremiumModal} />

                        </>
                    ) : (
                        <CoverLetterEmptyState />
                    )}
                </>
            )}
            <Modal
                type={MOBILE_SLIDE_UP}
                show={showGoPremium}
                closeHandler={destroyGoPremiumModal}
                header={false}
                isGoPermium={true}
            >
                <PremiumFeatureModal closeHandler={destroyGoPremiumModal} featureName={'resume'} />
            </Modal>
        </>
    );
};

export default index;